// components
import { Grid } from '@interstate/components/Grid';
import { VehicleTitle, VinStockRow, SellingPrice, AgeOfInventory, CompactVehicleImage } from './components';
import type { useVehicleListRowItemInStock } from '../useVehicleListRowItemInStock';
import { getCompactGridBreakpoints } from './getCompactGridBreakpoints';

type VehicleListRowItemInStockCompactNotSelectedProps = {
    vehicleData: ReturnType<typeof useVehicleListRowItemInStock>;
    forceSmallBreakpoint?: boolean;
};

export const VehicleListRowItemInStockCompactNotSelected = ({
    vehicleData,
    forceSmallBreakpoint
}: VehicleListRowItemInStockCompactNotSelectedProps) => {
    const {
        imageUrl,
        year,
        make,
        model,
        vin,
        stockNumber,
        vehicleListItemTitle,
        formattedPrice,
        ageDays,
        shouldShowAgeOfInventory
    } = vehicleData;

    return (
        <Grid container spacing={1} alignItems="center" flexGrow={1}>
            <Grid xs="auto">
                <CompactVehicleImage vehicle={{ imageUrl, year, make, model }} />
            </Grid>
            <Grid xs={10} flexGrow={1}>
                <Grid container spacing={1} alignItems="center" flexGrow={1}>
                    <Grid
                        {...getCompactGridBreakpoints({ xs: 12, xl: 4, forceSmallBreakpoint })}
                        display="flex"
                        gap={2}
                        flexWrap="nowrap"
                    >
                        <VehicleTitle title={vehicleListItemTitle} />
                    </Grid>
                    <Grid
                        {...getCompactGridBreakpoints({ xs: 12, xl: 5, forceSmallBreakpoint })}
                        display="flex"
                        alignItems="center"
                        gap={1}
                    >
                        <VinStockRow vin={vin} stockNumber={stockNumber} />
                    </Grid>
                    <Grid
                        {...getCompactGridBreakpoints({ xs: 12, xl: 3, forceSmallBreakpoint })}
                        display="flex"
                        flexDirection="column"
                        gap={1}
                    >
                        <SellingPrice formattedPrice={formattedPrice} />
                        {shouldShowAgeOfInventory && <AgeOfInventory ageDays={ageDays} />}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
